/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export class SearchModel {
  constructor(
    public search_criteria: object,
    public skip: number = 0,
    public limit: number = 0,
    public sort: string = '',
    public select: string = ''
  ) {}
}
